import gql from 'graphql-tag';

export default gql`
  query getUpcomingInvoiceItems(
    $customer_id: ID
    $subscription_id: ID
  ) {
    getUpcomingInvoiceItems(
      customer_id: $customer_id
      subscription_id: $subscription_id
      limit: 100
    ) {
      has_more
      data {
        id
        amount
        description
        quantity
        period {
          start
          end
        }
        plan {
          id
          active
          amount
          nickname
          usage_type
        }
      }
    }
  }
`;
